import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { mainRoutes } from "router/router";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function App() {
  const router = createBrowserRouter(mainRoutes);
  return (
    <>
      <ToastContainer />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
